export default "__VITE_ASSET__B4Z_fVqV__"